/**
 * @file vue 自定义指令封装
 * @version
 * @author pankzou
 * @date 2021-09-13
 * @lastModified
 * @lastModifiedDate
 */

/**
 * 定义 vue 的全局指令
 * 使用时，在 mian.js 文件中进行引用
 *
 * @example
 * 加载模块
 * import directives from './directives/index' // 全局指令封装
 *
 * 在 main.js 中注册
 * for (let key in directives) {
 *   Vue.directive(key, directives[key])
 * }
 *
 * 在 .vue 文件中使用
 * <input v-focus type='text' name='username'/>
 */

export default {
    /**
     * 表单自动获取焦点
     */
    focus: {
        // bind：只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
        bind: function (el) {},

        // inserted：被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。
        inserted: function (el) {
            el.focus();
        },

        // update：所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。指令的值可能发生了改变，也可能没有。
        update: function (el) {},

        // componentUpdated：指令所在组件的 VNode 及其子 VNode 全部更新后调用。
        componentUpdated: function () {},

        // unbind：只调用一次，指令与元素解绑时调用。
        unbind: function () {},
    },

    /**
     * 输入框实时搜索（节流）
     */
    debounce: {
        /**
         * v-debounce
         * @param el 绑定的结点
         * @param binding 通过自定义指令传递的参数，可以是函数，如果是函数就直接binding.value()进行执行
         *
         */
        inserted: function (el, binding) {
            let timer;
            el.addEventListener('keyup', () => {
                if (timer) {
                    clearTimeout(timer)
                }
                timer = setTimeout(() => {
                    binding.value()
                }, 300)
            })
        }
    }
}